var exports = {
  "R": "FocusRing.module__focusRing___RExfWm",
};

module.exports = exports;
